import React from "react";
import { HiChevronRight } from "react-icons/hi";
import ProjectCard from "../common/ProjectCard";
import { Link } from "react-router-dom";
import { useGetProjectsQuery } from "../../redux/slices/api/projectsApiSlice";
import { Bars } from "react-loader-spinner";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper";

import { Pagination, Navigation } from "swiper";
const OpenFundingCalls = () => {
  const { data: projectsData, isLoading } = useGetProjectsQuery();
  return (
    <div className="w-full flex flex-col">
      {/* Section Header */}
      <div className="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-12">
        <div className="flex flex-col">
          <span className="text-primary roboto-font text-sm font-medium uppercase tracking-wider mb-3">
            Fund Research
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl abel-font text-secondary">
            Open Funding Calls
          </h2>
        </div>
        <Link
          to="/projects"
          className="group flex items-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-primary/10 to-primary-green/10 hover:from-primary/20 hover:to-primary-green/20 border border-primary/20 transition-all duration-300"
        >
          <span className="text-primary font-medium">See all projects</span>
          <HiChevronRight
            className="text-primary group-hover:translate-x-1 transition-transform duration-300"
            size={20}
          />
        </Link>
      </div>

      {isLoading ? (
        <div className="w-full min-h-[400px] flex justify-center items-center">
          <div className="flex flex-col items-center gap-4">
            <Bars
              height="50"
              width="50"
              color="#8538ff"
              ariaLabel="bars-loading"
              visible={true}
            />
            <span className="text-gray-500 roboto-font">Loading projects...</span>
          </div>
        </div>
      ) : projectsData?.length > 0 ? (
        <div className="w-full h-[650px]">
          <Swiper
            pagination={{
              clickable: true,
              dynamicBullets: true,
              dynamicMainBullets: 5,
            }}
            spaceBetween={24}
            slidesPerGroup={1}
            loop={projectsData?.length > 3}
            breakpoints={{
              300: {
                slidesPerView: 1,
                spaceBetween: 16,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1124: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
              1540: {
                slidesPerView: 4,
                spaceBetween: 24,
              },
            }}
            navigation={true}
            modules={[Pagination, Navigation]}
            className="open-calls-slider"
          >
            {projectsData?.map((project, index) => (
              <SwiperSlide key={index}>
                <ProjectCard data={project} isSlide={true} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        <div className="w-full min-h-[400px] flex flex-col justify-center items-center empty-state-container-light p-12">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-primary/10 to-primary-green/10 flex items-center justify-center mb-6">
            <svg className="w-10 h-10 text-primary/40" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
          </div>
          <h3 className="text-2xl font-semibold text-secondary mb-2">No Open Funding Calls</h3>
          <p className="text-gray-500 text-center max-w-md mb-6">
            There are currently no projects seeking funding. Be the first to launch your research project!
          </p>
          <Link
            to="/create-project"
            className="px-6 py-3 bg-gradient-to-r from-primary to-[#7e7cff] text-white rounded-xl font-medium hover:shadow-lg hover:shadow-primary/20 transition-all duration-300"
          >
            Create a Project
          </Link>
        </div>
      )}
    </div>
  );
};

export default OpenFundingCalls;
